import React from 'react'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import LinesEllipsis from 'react-lines-ellipsis'
import useIsMobile from 'components/program-marketing/useIsMobile'

const TextEllipsis = responsiveHOC()(LinesEllipsis)

const ReadMoreLink = ({ onClick }) => (
  <span>
    ...{' '}
    <Link
      style={{
        color: 'inherit',
        textDecoration: 'underline',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      Read More
    </Link>
  </span>
)

const ReadMore = ({
  text,
  maxLine = 2,
  maxLineMobile = 2,
  basedOn = 'words',
  onClick,
}) => {
  const isMobile = useIsMobile()
  return (
    <Typography component="span" variant="body1">
      <TextEllipsis
        copmonent="span"
        text={text}
        maxLine={isMobile ? maxLineMobile : maxLine}
        trimRight
        basedOn={basedOn}
        ellipsis={<ReadMoreLink onClick={onClick} />}
      />
    </Typography>
  )
}

export default ReadMore
